// removed by extract-text-webpack-plugin
module.exports = {"grid-container":"reports-grid__grid-container___1OKRj"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/reports/reports-grid.scss
// module id = 1350
// module chunks = 0